import React from 'react';
import { Switch, Redirect } from 'react-router';
import { Grid } from '@material-ui/core';
import dashboardRoutes from '../routes/dashboard';
import {
  MainBar,
  ProtectedRoute,
  IntercomComponent,
  MediaPreviewModal,
} from '../components';
import { getClassesForPages } from './utils';
import useStyles from './styles';
import PromoNote from '../views/pages/Pricing/components/PromoNote/PromoNote';

const DashboardLayout = () => {
  const classes = useStyles();
  const contentStyle = (window.location.href.indexOf('dashboard/errors') !== -1)
    ? classes.errorPageContent
    : classes.content;

  const dashboardClasses = getClassesForPages(classes);

  return (
    <>
      <MainBar />
      <PromoNote />
      <Grid container className={`${classes.container} ${dashboardClasses}`}>
        <Grid item className={contentStyle}>
          <Switch>
            {dashboardRoutes.map((route) => {
              if (route.redirect) {
                const from = Array.isArray(route.path)
                  ? route.path[0]
                  : route.path;
                const to = Array.isArray(route.redirect.path)
                  ? route.redirect.path[0]
                  : route.redirect.path;

                if (to) {
                  return (
                    <Redirect
                      from={from}
                      to={to}
                      key={`${from}_${to}`}
                    />
                  );
                }
                return null;
              }
              return (
                <ProtectedRoute
                  {...route}
                  key={JSON.stringify(route.path)}
                  exact
                />
              );
            })}
          </Switch>
          <div style={{ height: 100 }} />
        </Grid>
      </Grid>
      <MediaPreviewModal />
      <IntercomComponent />
    </>
  );
};

export default DashboardLayout;
